import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, ThumbsUpIcon } from 'lucide-react';
import { toast } from 'sonner';
import { agencies } from '../data/mockAgencies';
import { PageHeader } from '../components/common/PageHeader';
import { BottomSheet } from '../components/common/BottomSheet';
const tabs = ['机构介绍', '顾问团队', '服务套餐', '用户评价'] as const;
const consultants = [{
  name: '张老师',
  role: '资深顾问',
  exp: '10 年',
  avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=120'
}, {
  name: '李老师',
  role: '申请主导师',
  exp: '8 年',
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120'
}, {
  name: '王老师',
  role: '文书导师',
  exp: '6 年',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120'
}];
const packages = [{
  name: '名校精英计划',
  price: '￥58,000',
  tags: ['冲刺英港新', '三对一', '不限申请'],
  desc: '主打冲刺 QS Top 50 名校。'
}, {
  name: '标准申请套餐',
  price: '￥38,000',
  tags: ['性价比', '6 所申请'],
  desc: '覆盖申请全流程，性价比之选。'
}, {
  name: '半 DIY 辅导',
  price: '￥18,000',
  tags: ['文书 + 网申'],
  desc: '适合自主性强、预算有限的同学。'
}];
const reviews = [{
  u: '陈同学',
  stars: 5,
  c: '主导师非常专业，文书改得很细致，最终拿到了梦校 offer。'
}, {
  u: '王同学',
  stars: 5,
  c: '服务流程清晰，每个节点都有跟进，省心。'
}, {
  u: '李同学',
  stars: 4,
  c: '整体不错，签证阶段稍慢，但最终顺利。'
}];
const slots = ['今天 10:00', '今天 14:00', '今天 19:00', '明天 10:00', '明天 14:00', '明天 19:00'];
export function AgencyDetail() {
  const {
    id
  } = useParams();
  const a = agencies.find(x => x.id === id) || agencies[0];
  const [tab, setTab] = useState<(typeof tabs)[number]>('机构介绍');
  const [book, setBook] = useState(false);
  const [chat, setChat] = useState(false);
  const [slot, setSlot] = useState<string | null>(null);
  return <div className="bg-slate-50 min-h-screen pb-24" data-id="element-217">
      <PageHeader title={a.name} data-id="element-218" />

      <div className="m-3 bg-white rounded-2xl p-4" data-id="element-219">
        <div className="flex items-center gap-3" data-id="element-220">
          <div className="w-14 h-14 rounded-xl flex items-center justify-center text-white font-bold text-xl" style={{
          background: a.logoBg
        }} data-id="element-221">
            {a.logoText}
          </div>
          <div className="flex-1 min-w-0" data-id="element-222">
            <div className="font-bold text-slate-800" data-id="element-223">{a.name}</div>
            <div className="text-[11px] text-slate-500 mt-0.5" data-id="element-224">
              {a.region} · {a.size}
            </div>
            <div className="flex items-center gap-3 mt-1 text-xs" data-id="element-225">
              <span className="text-amber-600 font-semibold flex items-center gap-0.5" data-id="element-226">
                <StarIcon size={12} fill="currentColor" data-id="element-227" /> {a.rating}
              </span>
              <span className="text-slate-500" data-id="element-228">
                {a.cases.toLocaleString()} 服务案例
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white sticky top-12 z-10 border-b border-slate-100" data-id="element-229">
        <div className="flex" data-id="element-230">
          {tabs.map(t => <button key={t} onClick={() => setTab(t)} className={`flex-1 py-3 text-sm relative ${tab === t ? 'text-blue-600 font-bold' : 'text-slate-600'}`} data-id="element-231">
              {t}
              {tab === t && <motion.div layoutId="ag-tab" className="absolute bottom-0 left-1/4 right-1/4 h-0.5 bg-blue-600 rounded" data-id="element-232" />}
            </button>)}
        </div>
      </div>

      <AnimatePresence mode="wait" data-id="element-233">
        <motion.div key={tab} initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} className="p-3 space-y-3" data-id="element-234">
          {tab === '机构介绍' && <div className="bg-white rounded-2xl p-4" data-id="element-235">
              <p className="text-sm text-slate-600 leading-relaxed" data-id="element-236">
                {a.intro}
              </p>
              <div className="flex flex-wrap gap-1.5 mt-3" data-id="element-237">
                {a.strong.map(t => <span key={t} className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded" data-id="element-238">
                    {t}
                  </span>)}
              </div>
            </div>}
          {tab === '顾问团队' && consultants.map(c => <div key={c.name} className="bg-white rounded-2xl p-4 flex items-center gap-3" data-id="element-239">
                <img src={c.avatar} alt="" className="w-12 h-12 rounded-full object-cover bg-slate-100" data-id="element-240" />
                <div className="flex-1" data-id="element-241">
                  <div className="font-bold text-slate-800" data-id="element-242">{c.name}</div>
                  <div className="text-xs text-slate-500 mt-0.5" data-id="element-243">
                    {c.role} · {c.exp}经验
                  </div>
                </div>
                <button className="text-xs text-blue-600 font-semibold" data-id="element-244">
                  查看
                </button>
              </div>)}
          {tab === '服务套餐' && packages.map(p => <div key={p.name} className="bg-white rounded-2xl p-4" data-id="element-245">
                <div className="flex items-start justify-between" data-id="element-246">
                  <div data-id="element-247">
                    <div className="font-bold text-slate-800" data-id="element-248">{p.name}</div>
                    <div className="text-xs text-slate-500 mt-1" data-id="element-249">{p.desc}</div>
                  </div>
                  <div className="text-blue-600 font-extrabold" data-id="element-250">{p.price}</div>
                </div>
                <div className="flex flex-wrap gap-1 mt-2" data-id="element-251">
                  {p.tags.map(t => <span key={t} className="text-[10px] bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded" data-id="element-252">
                      {t}
                    </span>)}
                </div>
                <div className="flex gap-2 mt-3" data-id="element-253">
                  <button onClick={() => setChat(true)} className="flex-1 h-9 rounded-full border border-blue-500 text-blue-600 text-sm font-semibold" data-id="element-254">
                    立即咨询
                  </button>
                  <button onClick={() => setBook(true)} className="flex-1 h-9 rounded-full bg-blue-600 text-white text-sm font-semibold" data-id="element-255">
                    预约咨询
                  </button>
                </div>
              </div>)}
          {tab === '用户评价' && reviews.map((r, i) => <div key={i} className="bg-white rounded-2xl p-4" data-id="element-256">
                <div className="flex items-center gap-2" data-id="element-257">
                  <span className="font-bold text-slate-800 text-sm" data-id="element-258">
                    {r.u}
                  </span>
                  <span className="flex" data-id="element-259">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} size={12} className={i < r.stars ? 'text-amber-500' : 'text-slate-200'} fill="currentColor" data-id="element-260" />)}
                  </span>
                </div>
                <p className="text-sm text-slate-600 mt-1.5 leading-relaxed" data-id="element-261">
                  {r.c}
                </p>
                <button className="text-xs text-slate-500 mt-2 flex items-center gap-1" data-id="element-262">
                  <ThumbsUpIcon size={12} data-id="element-263" /> 12
                </button>
              </div>)}
        </motion.div>
      </AnimatePresence>

      {/* Booking sheet */}
      <BottomSheet open={book} onClose={() => setBook(false)} title="预约咨询" maxHeight="60vh" data-id="element-264">
        <div className="p-4" data-id="element-265">
          <div className="text-sm text-slate-600 mb-3" data-id="element-266">
            选择您方便的时间，顾问将与您联系：
          </div>
          <div className="grid grid-cols-2 gap-2" data-id="element-267">
            {slots.map(s => <button key={s} onClick={() => setSlot(s)} className={`h-11 rounded-xl border-2 text-sm font-medium ${slot === s ? 'border-blue-600 bg-blue-50 text-blue-700' : 'border-slate-200 text-slate-700'}`} data-id="element-268">
                {s}
              </button>)}
          </div>
          <button onClick={() => {
          setBook(false);
          toast.success(`已预约 ${slot || '默认时段'}`);
        }} className="w-full h-11 mt-4 rounded-full bg-blue-600 text-white font-semibold text-sm" data-id="element-269">
            确认预约
          </button>
        </div>
      </BottomSheet>

      {/* Chat sheet */}
      <BottomSheet open={chat} onClose={() => setChat(false)} title={`与 ${a.name} 顾问对话`} maxHeight="70vh" data-id="element-270">
        <div className="flex flex-col h-[60vh]" data-id="element-271">
          <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-slate-50" data-id="element-272">
            <div className="flex gap-2 max-w-[80%]" data-id="element-273">
              <div className="w-7 h-7 rounded-full bg-blue-600 text-white text-xs flex items-center justify-center shrink-0" data-id="element-274">
                顾
              </div>
              <div className="bg-white rounded-xl p-2.5 text-sm text-slate-700 shadow-sm" data-id="element-275">
                您好，我是您的专属顾问，请问有什么可以帮您？
              </div>
            </div>
          </div>
          <div className="border-t border-slate-100 p-2 flex gap-2 bg-white" data-id="element-276">
            <input placeholder="输入消息..." className="flex-1 h-10 px-3 rounded-full bg-slate-100 text-sm outline-none" aria-label="消息输入" data-id="element-277" />
            <button className="px-4 h-10 rounded-full bg-blue-600 text-white text-sm font-semibold" data-id="element-278">
              发送
            </button>
          </div>
        </div>
      </BottomSheet>
    </div>;
}